import React from 'react';
import { Compass } from '@/utils/icons';

interface TourWelcomeProps {
  /** Start the first guided tour. */
  onStart: () => void;
  /** Opt out of all auto-start tours (still replayable from the menu). */
  onSkipAll: () => void;
}

/**
 * One-time welcome shown before the very first auto-start tour, so users know
 * what the spotlight overlay is and how to get back to tutorials later.
 */
const TourWelcome: React.FC<TourWelcomeProps> = ({ onStart, onSkipAll }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ zIndex: 1100, animation: 'fadeIn 0.2s ease' }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="tour-welcome-title"
      aria-describedby="tour-welcome-desc"
    >
      <div className="absolute inset-0" style={{ backgroundColor: 'var(--modal-backdrop)' }} aria-hidden />
      <div
        className="cgm-card cgm-modal-panel relative p-6 w-full max-w-md"
        style={{ zIndex: 1101, transition: 'none', animation: 'fadeIn 0.2s ease' }}
      >
        <div className="flex items-center gap-2 mb-1">
          <Compass className="w-5 h-5 cgm-text-primary" aria-hidden />
          <h3 id="tour-welcome-title" className="text-lg font-semibold cgm-text-primary">
            Welcome! Let us show you around
          </h3>
        </div>
        <p id="tour-welcome-desc" className="cgm-text-secondary text-sm mt-2 leading-relaxed">
          Short guided tours will point out the key features on each screen as
          you reach it — each takes under a minute, and you can leave one at
          any time. Replay any of them later from{' '}
          <span className="inline-flex items-center gap-1 font-medium cgm-text-primary">
            <Compass className="w-3.5 h-3.5" aria-hidden />
            Tutorials
          </span>{' '}
          in the sidebar.
        </p>
        <div className="flex items-center justify-end gap-2 mt-6">
          <button type="button" onClick={onSkipAll} className="cgm-button-flat py-2 px-4 text-sm">
            Skip the tours
          </button>
          <button type="button" onClick={onStart} className="cgm-button py-2 px-4 text-sm">
            Show me around
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourWelcome;
